var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditorjsColumns(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 -1 14 14",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("rect", {
    x: 1.194,
    y: -0.041,
    width: 11.601,
    height: 12.11,
    rx: 1,
    ry: 1,
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(0, 0, 0)",
      strokeWidth: "1.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(0, 0, 0)",
      strokeWidth: "1.5px"
    },
    d: "M 7.032 -0.034 L 6.948 11.842"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditorjsColumns);
export default __webpack_public_path__ + "static/media/editorjsColumns.fc13976cc994104a17ad04375b2f8c51.svg";
export { ForwardRef as ReactComponent };